import React from "react";

import BackNavigationButton from "../../../../components/Habitacional/core/BackNavigationButton";
import CardActivateInsurance from "../../../../components/Habitacional/CardActivateInsurance/CardActivateInsurance";
import ContentSection from "../../../../components/Habitacional/ContentSection";
import FormDFI from "./FormDFI/FormDFI";
import FormMIP from "./FormMIP/FormMIP";

import { ReactComponent as DFI } from "../../../../assets/images/habitacional/dfi-icon.svg";
import { ReactComponent as MIP } from "../../../../assets/images/habitacional/mip-icon.svg";

import envs from "../../../../config/envs";

const TabItems = [
  {
    icon: <DFI />,
    title: "Danos físicos ao imóvel (DFI)",
    buttonText: "Acionar cobertura",
    link: `${envs.hostStaticCdn}/reguas/arquivos/seguro_habitacional_coberturas_e_assistencias.pdf`,
    textlink: "Saiba mais",
    content: (
      <>
        <FormDFI />
      </>
    ),
  },
  {
    icon: <MIP />,
    title: "Morte ou invalidez permanente (MIP)",
    buttonText: "Acionar cobertura",
    link: `${envs.hostStaticCdn}/reguas/arquivos/seguro_habitacional_coberturas_e_assistencias.pdf`,
    textlink: "Saiba mais",
    content: (
      <>
        <FormMIP />
      </>
    ),
  },
];

const ChooseCoverageToActivate = () => {
  return (
    <>
      <BackNavigationButton href="/paravoce/habitacional" isPadding />
      <ContentSection title="Escolha a cobertura que quer acionar e em seguida preencha os dados ">
        <CardActivateInsurance CardActivateInsuranceItem={TabItems} />
      </ContentSection>
    </>
  );
};

export default ChooseCoverageToActivate;
